import { AxiosRequestConfig } from 'axios';
import { useCreateQuery, QueryOptions } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { lumaBotFlowBaseModel } from './crud';
import { ILumaBotFlowResponses } from './types';

export interface TUseLumaBotFlowSnapshotParams {
  flowId: string;
  showWholeSession?: boolean;
}

export interface TUseLumaBotFlowSnapshotResponse {
  response: Array<ILumaBotFlowResponses>;
}

export const useLumaBotFlowSnapshot = (
  params: TUseLumaBotFlowSnapshotParams,
  options?: QueryOptions<AxiosRequestConfig['params']>,
) => {
  const { keysV2 } = lumaBotFlowBaseModel;
  const { flowId, showWholeSession } = params;

  async function queryFn() {
    const { data } = await axiosService.get(
      `${keysV2.basicUrlPath}/${flowId}/snapshot`,
      {
        params: {
          showWholeSession,
        },
      },
    );

    return data;
  }

  return useCreateQuery<TUseLumaBotFlowSnapshotResponse>(
    ['snapshot', params],
    queryFn,
    params,
    options,
  );
};
